import { render, staticRenderFns } from "./reconciliationdetail.vue?vue&type=template&id=20e7dd1e&"
import script from "./reconciliationdetail.vue?vue&type=script&lang=ts&"
export * from "./reconciliationdetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports